import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import "../../../styles/Pages/UniversalComponents/PageHeader.style.css";
import ArrowRight from "../../../assets/Icons/Pages/UniversalComponents/PageHeader/ArrowRight.svg";
import PropTypes from "prop-types";
const PageHeader = ({ renderCustomElement, title }) => {
  const location = useLocation();
  const [pagePath, setPagePath] = useState(null); //save the path array to this state
  const { id } = useParams();

  useEffect(() => {
    const extractedPath = location.pathname.replace(`/${id}`, "").split("/");
    setPagePath(extractedPath);
  }, [location.pathname, id]);
  return (
    pagePath && (
      <div className="pageHeader">
        {renderCustomElement ? renderCustomElement : ""}

        <div className="w-full flex-row align-center justify-between">
          <div className="pageHeaderTitle" key={52152}>
            <div className="flex align-start justify-start g-05">
              {title
                ? title
                : pagePath[pagePath.length - 1].charAt(0).toUpperCase() +
                  pagePath[pagePath.length - 1].slice(1)}
            </div>
          </div>
          <div className="pageHeaderPath">
            {pagePath.map((data, index) => {
              return data !== "" ? (
                <>
                  <span
                    key={index}
                    className={
                      pagePath[pagePath.length - 2] === data
                        ? "colorGreen"
                        : pagePath[pagePath.length - 1] === data
                        ? "colorOrange"
                        : ""
                    }
                  >
                    {data.charAt(0).toUpperCase() + data.slice(1)}
                  </span>
                  {data !== pagePath[pagePath.length - 1] ? (
                    <img src={ArrowRight} alt="" />
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              );
            })}
          </div>
        </div>
      </div>
    )
  );
};

export default PageHeader;

PageHeader.propTypes = {
  renderCustomElement: PropTypes.element,
};
